<template>
  <el-row class="full-height" :gutter="10" style="margin: 0px; padding: 10px 4px">
    <el-col class="full-height" :span="8">
      <el-container class="full-height">
        <el-header height="auto" class="no-padding">
          <el-form size="small" label-position="top" @submit.native.prevent>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item label="Razão Social">
                  <el-input v-model="imobiliariaPesquisa.razaoSocial" @keyup.enter.native="pressEnterPesquisaNome" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <el-button @click="clickBotaoNovo" size="small" type="success">Novo</el-button>
                <el-button @click="clickBotaoPesquisar" size="small" type="primary">Pesquisar</el-button>
                <el-button @click="clickBotaoLimpar" size="small" type="warning">Limpar</el-button>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <span style="font-size: 14px; color: #777">{{ textoQtdImobiliarias }}</span>
              </el-col>
            </el-row>
          </el-form>
        </el-header>

        <el-main style="height: 100%; padding: 0px; margin-top: 10px">
          <el-table
            @row-dblclick="clickImobiliaria"
            :data="imobiliarias"
            empty-text="Nenhuma Imobiliária"
            height="100%"
            highlight-current-row
            stripe
          >
            <el-table-column label="ID" width="60" prop="id" />
            <el-table-column label="Nome" prop="razaoSocial" show-overflow-tooltip />
          </el-table>
        </el-main>
      </el-container>
    </el-col>
    <el-col :span="16" class="full-height">
      <el-container class="full-height">
        <el-header height="40px" style="padding: 10px 0px">
          <span style="color: #777; font-weight: bold">{{ textoImobiliariaSelecionada }}</span>
        </el-header>
        <el-main class="full-height" style="background: #FFF; padding: 10px 0px 0px 0px">
          <div class="tab-container">
            <el-tabs v-model="tabSelecionada" style="padding: 0px 10px">
              <el-tab-pane label="Detalhes" name="detalhes" class="full-height scrollable">
                <el-form size="small" ref="form" :rules="formRules" hide-required-asterisk :show-message="false" :model="imobiliaria">
                  <div style="color: #777; font-weight: bold; font-size: 15px">
                    <i class="el-icon-document" />
                    Pré Cadastro
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="14">
                        <el-form-item label="Razão Social" prop="razaoSocial">
                          <el-input v-model="imobiliaria.razaoSocial" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item label="CNPJ" prop="cnpj">
                          <el-input v-model="imobiliaria.cnpj" v-mask="'##.###.###/####-##'" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item>
                          <el-checkbox v-model="imobiliaria.status">Ativa</el-checkbox>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Data do Cadastro">
                          <el-input v-model="imobiliaria.dataCadastro" v-mask="'####-##-##'" placeholder="1999-09-09"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Data da Implantação">
                          <el-input v-model="imobiliaria.dataImplantacao" v-mask="'####-##-##'" placeholder="1999-09-09"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Data do Aceite">
                          <el-input v-model="imobiliaria.dataAceite" v-mask="'####-##-##'" placeholder="1999-09-09"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px">
                    <i class="el-icon-location" />
                    Informações Básicas
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="20">
                        <el-form-item label="Endereço" prop="endereco">
                          <el-input v-model="imobiliaria.endereco" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="Número" prop="numeroEndereco">
                          <el-input v-model="imobiliaria.numeroEndereco" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="20">
                        <el-form-item label="Complemento">
                          <el-input v-model="imobiliaria.complemento" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="4">
                        <el-form-item label="CEP" prop="cep">
                          <el-input v-model="imobiliaria.cep" v-mask="'#####-###'" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="4">
                        <el-form-item label="UF" prop="estado">
                          <el-select @change="changeEstado" v-model="imobiliaria.estado" value-key="id" placeholder="" filterable default-first-option style="width: 100%">
                            <el-option v-for="estado in estados" :key="estado.id" :label="estado.sigla" :value="estado" />
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Cidade" prop="cidade">
                          <el-select
                            @change="changeCidade"
                            v-model="imobiliaria.cidade"
                            :remote-method="pesquisarCidades"
                            :loading="isLoadingCidades"
                            value-key="id"
                            placeholder=""
                            loading-text="Carregando cidades"
                            no-data-text="Nenhuma cidade encontrada"
                            filterable
                            remote
                            default-first-option
                            style="width: 100%">
                              <el-option
                                v-for="cidade in cidades"
                                :key="cidade.id"
                                :label="cidade.nome"
                                :value="cidade">
                              </el-option>
                            </el-select>
                        </el-form-item>
                      </el-col>

                      <el-col :span="10">
                        <el-form-item label="Bairro" prop="bairro">
                          <el-select
                            v-model="imobiliaria.bairro"
                            :remote-method="pesquisarBairros"
                            :loading="isLoadingBairros"
                            value-key="id"
                            placeholder=""
                            loading-text="Carregando bairros"
                            no-data-text="Nenhum bairro encontrado"
                            filterable
                            remote
                            default-first-option
                            style="width: 100%">
                              <el-option v-for="bairro in bairros" :key="bairro.id" :label="bairro.nome" :value="bairro"/>
                            </el-select>
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="8">
                        <el-form-item label="Representante" prop="nomeRepresentante">
                          <el-input v-model="imobiliaria.nomeRepresentante" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="Cargo" prop="cargoRepresentante">
                          <el-input v-model="imobiliaria.cargoRepresentante" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item label="CPF" prop="cpfRepresentante">
                          <el-input v-model="imobiliaria.cpfRepresentante" v-mask="'###.###.###-##'" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>

              <el-tab-pane label="Proposta" name="proposta" class="full-height scrollable">
                <el-form 
                  :model="imobiliaria.propostaComercial" 
                  :rules="formRulesProposta" 
                  ref="formProposta"
                  size="small" 
                  label-position="top"
                  hide-required-asterisk
                  :show-message="false"
                >
                  <div v-if="isVisibleModulosContratados" style="color: #777; font-weight: bold; font-size: 15px">
                    <i class="el-icon-document" />
                    Módulos Contratados
                  </div>

                  <div v-if="isVisibleModulosContratados" style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-form-item>
                      <el-checkbox v-model="imobiliaria.propostaComercial.aluguel">Aluguel</el-checkbox>
                      <el-checkbox v-model="imobiliaria.propostaComercial.venda">Venda</el-checkbox>
                      <el-checkbox v-model="imobiliaria.propostaComercial.appVistoria">App de vistoria</el-checkbox>
                      <el-checkbox v-model="imobiliaria.propostaComercial.templateSite">Site</el-checkbox>
                      <el-checkbox v-model="imobiliaria.propostaComercial.contasEmail">E-mail</el-checkbox>
                    </el-form-item>
                  </div>

                  <div style="color: #777; font-weight: bold; font-size: 15px">
                    <i class="el-icon-document" />
                    Proposta Comercial
                  </div>
                  <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px">
                    <el-row :gutter="10">
                      <el-col :span="24">
                        <el-form-item label="Contato" prop="contato">
                          <el-input v-model="imobiliaria.propostaComercial.contato" />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="6">
                        <el-form-item label="Data" prop="data">
                          <el-input v-model="imobiliaria.propostaComercial.data" v-mask="'####-##-##'" placeholder="1999-09-09"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="18">
                        <el-form-item label="Vendedor" prop="vendedor">
                          <el-input v-model="imobiliaria.propostaComercial.vendedor" />
                        </el-form-item>
                      </el-col>
                    </el-row>

                    <el-row :gutter="10">
                      <el-col :span="2">
                        <el-form-item label=" ">
                          <el-radio label="PLANO_100" v-model="imobiliaria.propostaComercial.planoContratado">
                            <i class="el-icon-goods" />
                          </el-radio>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Plano até 100 imóveis" prop="plano100">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano100" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                       <el-col :span="2">
                        <el-form-item label=" ">
                          <el-radio label="PLANO_250" v-model="imobiliaria.propostaComercial.planoContratado">
                            <i class="el-icon-goods" />
                          </el-radio>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Plano até 250 imóveis" prop="plano250">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano250" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="2">
                        <el-form-item label=" ">
                          <el-radio label="PLANO_500" v-model="imobiliaria.propostaComercial.planoContratado">
                            <i class="el-icon-goods" />
                          </el-radio>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Plano até 500 imóveis" prop="plano500">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano500" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="2">
                        <el-form-item label=" " >
                          <el-radio label="PLANO_1000" v-model="imobiliaria.propostaComercial.planoContratado">
                            <i class="el-icon-goods" />
                          </el-radio>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Plano até 1000 imóveis" prop="plano1000">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano1000" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="2">
                        <el-form-item label=" ">
                          <el-radio label="PLANO_2000" v-model="imobiliaria.propostaComercial.planoContratado">
                            <i class="el-icon-goods" />
                          </el-radio>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Plano até 2000 imóveis" prop="plano2000">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano2000" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="2">
                        <el-form-item label=" ">
                          <el-radio label="PLANO_3000" v-model="imobiliaria.propostaComercial.planoContratado">
                            <i class="el-icon-goods" />
                          </el-radio>
                        </el-form-item>
                      </el-col>
                      <el-col :span="10">
                        <el-form-item label="Plano até 3000 imóveis" prop="plano3000">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano3000" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Acima de 3000 imóveis - incremento a cada 250 imóveis" prop="plano3000mais">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.plano3000mais" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Implantação, treinamento e acompanhamento presencial A partir do plano 500">
                          <el-input value="50% do plano/dia" readonly />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Implantação e treinamento remoto (2 horas)">
                          <el-input value="Incluso" readonly />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="Implantação e treinamento presencial (3 horas) A partir do plano 500">
                          <el-input value="50% do plano" readonly />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Importação SICADI/Sistemas Terceiros">
                          <el-input value="1 mensalidade do plano" readonly />
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Visita técnica - 2h" prop="visitaTecnica">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.visitaTecnica" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Site" prop="site">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.site" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row :gutter="10">
                      <el-col :span="12">
                        <el-form-item label="(Opcional) Site + 10 contas de e-mail" prop="siteEmail">
                          <div class="el-input el-input--small">
                            <money v-model="imobiliaria.propostaComercial.siteEmail" v-bind="moneyFormat" class="el-input__inner" />
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </div>
                </el-form>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-main>

        <el-footer height="52px" style="background-color: #D1D1D1; padding: 10px 10px;">
          <el-row style="height: 100%">
            <el-col :span="12" style="height: 100%">
              <el-row type="flex" justify="start" style="padding-top: 0px;">
                <el-button @click="gerarContrato" size="small" type="warning" v-if="visibilidadeGerarContrato">Gerar Contrato</el-button>
                <el-button @click="clickGerarProposta" size="small" type="warning" v-if="visibilidadeGerarProposta">Gerar Proposta</el-button>
              </el-row>
            </el-col>
            <el-col :span="12" style="height: 100%">
              <el-row type="flex" justify="end" style="padding-top: 0px;">
                <el-button v-if="isVisibleBotaoRemover" @click="clickBotaoRemover" size="small" type="danger">Remover</el-button>
                <el-button v-if="isVisibleBotaoGravar" @click="clickBotaoGravar" size="small" type="success">Gravar</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-footer>
        <app-alert-validacao @close="fecharAlertValidacao" :visibility="visibilidadeAlertValidar" :formValidacao="formValidacaoContrato"/>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import AppAlertValidacao from './AlertValidacao.vue'
import { mapActions, mapMutations, mapState } from 'vuex';
import { ESTADOS } from '../../util/constantes';
import { Money } from 'v-money';

export default {
  components: {
    AppAlertValidacao,
    Money,
  },

  data() {
    return {
      tabSelecionada: 'detalhes',

      imobiliariaPesquisa: {
        razaoSocial: '',
      },

      isLoadingCidades: false,
      isLoadingBairros: false,

      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      percentFormat: {
        decimal: ',',
        thousands: '.',
        suffix: ' %',
        precision: 2,
        masked: false
      },

      formRules: {
        razaoSocial: [{ required: true }],

        cnpj: [{ required: true, type: 'string', len: 18 }],

        estado: [{
          required: true,
          validator: this.validarEstado,
        }],

        cidade: [{
          required: true,
          validator: this.validarCidade,
        }],

        bairro: [{
          required: true,
          validator: this.validarBairro,
        }],
      },

      visibilidadeAlertValidar: false
    };
  },

  created() {
    this.atualizarImobiliarias();
  },

  computed: {
    ...mapState('loginStore', {
      usuarioLogado: state => state.usuarioLogado,
    }),

    ...mapState('imobiliariaPreCadastradaStore', {
      imobiliarias: state => state.imobiliarias,
      qtdImobiliarias: state => state.qtdImobiliarias,
      imobiliaria: state => state.imobiliariaSelecionada,
      formValidacaoContrato: state => state.formValidacaoContrato,
      cidades: state => state.cidades,
      bairros: state => state.bairros,
    }),

    estados: () => ESTADOS,

    textoQtdImobiliarias() {
      switch(this.qtdImobiliarias) {
        case 0:
          return 'Nenhuma Imobiliária Pré Cadastrada Encontrada';
        case 1:
          return '1 Imobiliária Pré Cadastrada Encontrada';
        default:
          return `${this.qtdImobiliarias} Imobiliárias Pré Cadastradas Encontradas`;
      }
    },

    isSelecionadaImobiliaria() {
      return this.imobiliaria.id !== 0;
    },
    isNotSelecionadaImobiliaria() {
      return this.imobiliaria.id === 0;
    },

    textoImobiliariaSelecionada() {
      if(this.isSelecionadaImobiliaria) {
        return `Imobiliárias Pré-Cadastro - ${this.imobiliaria.razaoSocial}`;
      }

      return 'Nova Imobiliária Pré Cadastrada';
    },

    isVisibleBotaoGravar() {
      return this.tabSelecionada === 'detalhes'
        || this.tabSelecionada === 'proposta';
    },
    isVisibleBotaoRemover() {
      return this.isSelecionadaImobiliaria
        && (this.tabSelecionada === 'detalhes' || this.tabSelecionada === 'proposta');
    },
    isVisibleModulosContratados() {
      return this.imobiliaria.propostaComercial !== null;
    },

    visibilidadeGerarProposta() {
      return this.isSelecionadaImobiliaria && this.tabSelecionada == 'proposta'
    },

    visibilidadeGerarContrato() {
      return this.isSelecionadaImobiliaria && this.tabSelecionada == 'detalhes'
    },

    formRulesProposta() {
      if(this.imobiliaria.id !== 0) {
        return {
          contato: [{ required: true }],
          data: [{ required: true }],
          vendedor: [{ required: true }],
          plano100: [{ required: true, type: 'number', min: 1 }],
          plano250: [{ required: true, type: 'number', min: 1 }],
          plano500: [{ required: true, type: 'number', min: 1 }],
          plano1000: [{ required: true, type: 'number', min: 1 }],
          plano2000: [{ required: true, type: 'number', min: 1 }],
          plano3000: [{ required: true, type: 'number', min: 1 }],
          plano3000mais: [{ required: true, type: 'number', min: 1 }],
          visitaTecnica: [{ required: true, type: 'number', min: 1 }],
          site: [{ required: true, type: 'number', min: 1 }],
          siteEmail: [{ required: true, type: 'number', min: 1 }]
        }
      } else {
        return {}
      }
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading',
    ]),


    ...mapMutations('imobiliariaPreCadastradaStore', {
      'limparFormImobiliariaMutation': 'limparFormImobiliaria',
      'limparCidadeMutation': 'limparCidade',
      'limparBairroMutation': 'limparBairro',
    }),

    ...mapActions('imobiliariaPreCadastradaStore', {
      'listarImobiliariasAction': 'listarImobiliarias',
      'recuperarImobiliariaAction': 'recuperarImobiliaria',
      'gravarImobiliariaAction': 'gravarImobiliaria',
      'removerImobiliariaAction': 'removerImobiliaria',
      'listarCidadesAction': 'listarCidades',
      'listarBairrosAction': 'listarBairros',
      'gerarContratoAction': 'gerarContrato',
      'gerarPropostaAction': 'gerarProposta',
    }),

    changeEstado() {
      this.limparCidade();
      this.limparBairro();
    },

    changeCidade() {
      this.limparBairro();
    },

    limparCidade() {
      this.limparCidadeMutation();
    },
    limparBairro() {
      this.limparBairroMutation();
    },

    pressEnterPesquisaNome() {
      this.atualizarImobiliarias();
    },

    clickBotaoNovo() {
      this.limparFormImobiliariaMutation();
      this.goToTab('detalhes');
    },

    clickBotaoPesquisar() {
      this.atualizarImobiliarias();
    },

    clickBotaoLimpar() {
      this.limparImobiliariaPesquisa();
    },

    clickImobiliaria(imobiliaria) {
      const payload = {
        id: imobiliaria.id,
      };

      this.goToTab('detalhes');
      this.recuperarImobiliaria(payload);
    },

    recuperarImobiliaria(payload) {
      this.showLoading();
      this.recuperarImobiliariaAction(payload)
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    atualizarImobiliarias() {
      const payload = { ...this.imobiliariaPesquisa };
      this.showLoading();
      this.listarImobiliariasAction(payload)
        .then()
        .finally(() => {
          this.hideLoading();
        });
    },

    clickBotaoGravar() {
      this.validarFormularioEGravar();
    },

    clickBotaoRemover() {
      this.confirmarERemoverImobiliaria();
    },

    clickGerarProposta() {
      const payload = {
        id: this.imobiliaria.id,
        razaoSocial: this.imobiliaria.razaoSocial,
      };

      this.showLoading();

      this.gerarPropostaAction(payload)
        .then(resultado => {
          const urlProposta = resultado.item;
          this.openNewTab(urlProposta);
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    openNewTab(url) {
      window.open(url, '_blank');
    },

    confirmarERemoverImobiliaria() {
      this.$confirm('Tem certeza de que deseja Remover a imobiliária?', 'Atenção', {
        type: 'warning',
      }).then(() => {
        this.removerImobiliaria();
      }).catch(() => {});
    },

    removerImobiliaria() {
      this.showLoading();

      const payload = {
        id: this.imobiliaria.id,
      };

      this.removerImobiliariaAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              this.atualizarImobiliarias();
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
          }
        })
        .catch()
        .finally(() => {
          this.hideLoading();
        });
    },

    validarFormularioEGravar() {
      this.$refs.form.validate(isFormValid => {
        this.$refs['formProposta'].validate(isFormPropostaValid => {
          if(isFormValid && isFormPropostaValid) {
            this.gravar();
          } else {
            this.exibirAlerta('Preencha todos os campos obrigatórios')
          }
        })
      });
    },

    gravar() {
      const payload = {
        ...this.imobiliaria,
        estado: {
          id: this.imobiliaria.estado.id,
          nome: this.imobiliaria.estado.nome,
        },
      };

      this.showLoading();
      this.gravarImobiliariaAction(payload)
        .then(resultado => {
          switch(resultado.status) {
            case 'SUCESSO':
              this.$message.success(resultado.mensagem);
              this.atualizarImobiliarias();
              break;
            case 'ERRO':
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.$message.error('Não foi possível conectar-se ao servidor');
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    gerarContrato() {
      if(this.formValidacaoContrato.endereco == ''
        || this.formValidacaoContrato.numeroEndereco == ''
        || this.formValidacaoContrato.cep == ''
        || this.formValidacaoContrato.nomeRepresentante == ''
        || this.formValidacaoContrato.cargoRepresentante == ''
        || this.formValidacaoContrato.cpfRepresentante == '' ) {
          this.visibilidadeAlertValidar = true;
          return;
      }

      if(this.imobiliaria.propostaComercial.aluguel == false && this.imobiliaria.propostaComercial.venda == false) {
        this.exibirAlerta('Impossível gerar contrato sem um módulo selecionado(Aluguel, Venda).')
        return;
      }

      const payload = {
        ...this.imobiliaria
      }

      this.showLoading();

      this.gerarContratoAction(payload)
      .then((response) => {
        window.open(response.item, '_blank')
      })
      .finally(() => {
        this.hideLoading();
      })
    },

    exibirAlerta(mensagem) {
      this.$alert(mensagem, 'Atenção', {
        confirmButtonText: 'OK',
        type: 'warning',
      });
    },

    pesquisarCidades(nome) {
      if(this.imobiliaria.estado.id == 0 && nome !== '') {
        this.$message.warning("Selecione o estado");
        return;
      }
      const payload = {
        nome,
        estado: {
          id: this.imobiliaria.estado.id,
        },
      };
      
      this.isLoadingCidades = true;
      this.listarCidadesAction(payload)
      .then()
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
      .finally(() => {
        this.isLoadingCidades = false;
      });
    },

    pesquisarBairros(nome) {
      if(this.imobiliaria.cidade.id == 0 && nome !== '') {
        this.$message.warning("Selecione a cidade");
        return;
      }
      const payload = {
        nome,
        cidade: {
          id: this.imobiliaria.cidade.id,
        },
      };
      
      this.isLoadingBairros = true;
      this.listarBairrosAction(payload)
      .then()
      .catch(() => {
        this.$message.error("Não foi possível conectar-se com o servidor");
      })
      .finally(() => {
        this.isLoadingBairros = false;
      });
    },

    goToTab(newTab) {
      this.tabSelecionada = newTab;
    },

    validarEstado(rule, value, callback) {
      if(!value) {
        return callback(new Error());
      }

      if(value.id < 1) {
        return callback(new Error());
      }

      return callback();
    },

    validarCidade(rule, value, callback) {
      if(!value) {
        return callback(new Error());
      }

      if(value.id < 1) {
        return callback(new Error());
      }

      return callback();
    },

    validarBairro(rule, value, callback) {
      if(!value) {
        return callback(new Error());
      }

      if(value.id < 1) {
        return callback(new Error());
      }

      return callback();
    },

    limparImobiliariaPesquisa() {
      this.imobiliariaPesquisa = {
        razaoSocial: '',
      };
    },

    fecharAlertValidacao() {
      this.visibilidadeAlertValidar = false
    }
  },
}
</script>

<style>

</style>